import { API_PDC_URL_V3 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { getQueryString } from "../../services/rest-api-call";
import { overflowNotificationConstants } from "../overflowNotification";

export const exportConstants = {
  DEADLINES_EXPORT_START: "DEADLINES_EXPORT_START",
  DEADLINES_EXPORT_SUCCESS: "DEADLINES_EXPORT_SUCCESS",
  DEADLINES_EXPORT_ERROR: "DEADLINES_EXPORT_ERROR"
};

export function exportDeadlinesCsv(companyUuid, queryParameters) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuid = getState().main.accountantUuidSelected;

    const params = {
      managerId: accountantUuid,
      ...queryParameters
    };

    if (companyUuid) {
      queryParameters.itemId = companyUuid;
    }

    let newParams = getQueryString(params);
    newParams = newParams !== "" ? `?${newParams}` : "";

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: API_PDC_URL_V3 + "/deadlines/export" + newParams,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          "X-Item-ID": main.companyUuidSelected
        }
      };

      dispatch({
        type: exportConstants.DEADLINES_EXPORT_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          dispatch({
            type: exportConstants.DEADLINES_EXPORT_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: exportConstants.DEADLINES_EXPORT_ERROR,
            payload: { error: response }
          });
          reject();
        });
    });
  };
}

export function sendDeadlinesEmail(companyUuid, queryParameters) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const myType = main.myType;
    const accountantUuid = main.accountantUuidSelected;

    const bodyRequest = {
      managerId: accountantUuid,
      ...queryParameters
    };

    if (companyUuid) {
      bodyRequest.itemId = companyUuid;
    }

    const additionalHeaders = {
      "X-Manager-ID": accountantUuid
    };

    if (companyUuid) {
      additionalHeaders["X-Item-ID"] = companyUuid;
    }

    let newParams = getQueryString(bodyRequest);
    newParams = newParams !== "" ? `?${newParams}` : "";

    return new Promise(function(resolve, reject) {
      dispatch({
        type: exportConstants.DEADLINES_EXPORT_START
      });

      let request = {
        method: "POST",
        url: API_PDC_URL_V3 + "/deadlines/export" + newParams,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: bodyRequest
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: exportConstants.DEADLINES_EXPORT_SUCCESS,
            payload: response.data
          });
          dispatch({
            type: overflowNotificationConstants.SHOW_OVERFLOW,
            payload: {
              type: "success",
              title: "",
              message:
                myType !== "STUDIO"
                  ? "Le scadenze sono state inviate all’indirizzo email dell'azienda"
                  : "Le scadenze sono state inviate all’indirizzo email dello studio"
            }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: exportConstants.DEADLINES_EXPORT_ERROR,
            payload: { error: err }
          });
          dispatch({
            type: overflowNotificationConstants.SHOW_OVERFLOW,
            payload: {
              type: "error",
              title: "",
              message: "Errore durante l'invio della mail"
            }
          });
          reject();
        });
    });
  };
}
